import { render, staticRenderFns } from "./VChart3.vue?vue&type=template&id=239ba36a&"
import script from "./VChart3.vue?vue&type=script&lang=js&"
export * from "./VChart3.vue?vue&type=script&lang=js&"
import style0 from "./VChart3.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports